// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import authService from '../../services/authService';
// import stockService from '../../services/stockService';
// import ToastService from '../../services/toastService';
// import Sidebar from '../Sidebar/Sidebar';
//
// const Stocks = () => {
//   const navigate = useNavigate();
//   const [showSidebar, setShowSidebar] = useState(false);
//   const [stockData, setStockData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 1,
//     total: 0,
//     limit: 10
//   });
//   const [searchTerm, setSearchTerm] = useState('');
//   const [searchInput, setSearchInput] = useState('');
//   const [inventoryInfo, setInventoryInfo] = useState(null);
//   const [shiftActive, setShiftActive] = useState(false);
//
//   // Pull to refresh states
//   const [refreshing, setRefreshing] = useState(false);
//   const [pullDistance, setPullDistance] = useState(0);
//   const touchStartY = useRef(0);
//   const containerRef = useRef(null);
//   const searchTimeoutRef = useRef(null);
//
//   useEffect(() => {
//     // Check authentication
//     if (!authService.isAuthenticated()) {
//       ToastService.error('Session expired. Please login again.');
//       navigate('/login');
//       return;
//     }
//
//     // Check if shift is active and get inventoryId
//     checkShiftStatus();
//   }, [navigate]);
//
//   useEffect(() => {
//     if (shiftActive && inventoryInfo?.id) {
//       fetchStockData();
//     }
//   }, [shiftActive, inventoryInfo?.id, pagination.currentPage, searchTerm]);
//
//   // Debounced search
//   useEffect(() => {
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }
//
//     searchTimeoutRef.current = setTimeout(() => {
//       setSearchTerm(searchInput);
//       setPagination(prev => ({ ...prev, currentPage: 1 }));
//     }, 500);
//
//     return () => {
//       if (searchTimeoutRef.current) {
//         clearTimeout(searchTimeoutRef.current);
//       }
//     };
//   }, [searchInput]);
//
//   const checkShiftStatus = () => {
//     // Get shift data from localStorage
//     const shiftDataStr = localStorage.getItem('current_shift');
//
//     if (shiftDataStr) {
//       const shiftData = JSON.parse(shiftDataStr);
//
//       if (shiftData.isActive && shiftData.inventoryId) {
//         setShiftActive(true);
//         setInventoryInfo({
//           id: shiftData.inventoryId,
//           name: shiftData.inventoryName || 'Current Inventory'
//         });
//
//         // Also try to get inventory name from other localStorage items if available
//         const inventoryName = localStorage.getItem('currentInventoryName');
//         if (inventoryName) {
//           setInventoryInfo(prev => ({ ...prev, name: inventoryName }));
//         }
//       } else {
//         setShiftActive(false);
//         setInventoryInfo(null);
//       }
//     } else {
//       setShiftActive(false);
//       setInventoryInfo(null);
//     }
//
//     setLoading(false);
//   };
//
//   const fetchStockData = async () => {
//     try {
//       setLoading(true);
//
//       const response = await stockService.getStockByInventory(
//         inventoryInfo.id,
//         pagination.currentPage,
//         pagination.limit,
//         searchTerm
//       );
//
//       if (response.success) {
//         setStockData(response.data);
//         setPagination({
//           ...pagination,
//           totalPages: response.pagination.totalPages,
//           total: response.pagination.total
//         });
//       } else {
//         setStockData([]);
//         setPagination({
//           ...pagination,
//           totalPages: 0,
//           total: 0
//         });
//       }
//     } catch (error) {
//       console.error('Error fetching stock data:', error);
//       setStockData([]);
//       setPagination({
//         ...pagination,
//         totalPages: 0,
//         total: 0
//       });
//
//       if (error.message.includes('401') || error.message.includes('Unauthorized')) {
//         ToastService.error('Session expired. Please login again.');
//         navigate('/login');
//       } else if (!error.message.includes('404')) {
//         ToastService.error('Failed to load stock data. Please try again.');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };
//
//   // Pull to refresh handlers
//   const handleTouchStart = (e) => {
//     if (containerRef.current && containerRef.current.scrollTop === 0) {
//       touchStartY.current = e.touches[0].clientY;
//     }
//   };
//
//   const handleTouchMove = (e) => {
//     if (refreshing) return;
//
//     const touchY = e.touches[0].clientY;
//     const pull = touchY - touchStartY.current;
//
//     if (pull > 0 && containerRef.current && containerRef.current.scrollTop === 0) {
//       e.preventDefault();
//       setPullDistance(Math.min(pull, 100));
//     }
//   };
//
//   const handleTouchEnd = () => {
//     if (pullDistance > 60) {
//       handleRefresh();
//     }
//     setPullDistance(0);
//   };
//
//   const handleRefresh = async () => {
//     setRefreshing(true);
//     try {
//       await fetchStockData();
//       ToastService.success('Stock data refreshed', 1500);
//     } catch (error) {
//       ToastService.error('Refresh failed');
//     } finally {
//       setTimeout(() => setRefreshing(false), 500);
//     }
//   };
//
//   const handleSearch = (e) => {
//     setSearchInput(e.target.value);
//   };
//
//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= pagination.totalPages) {
//       setPagination(prev => ({ ...prev, currentPage: page }));
//
//       // Scroll to top on page change
//       if (containerRef.current) {
//         containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
//       }
//     }
//   };
//
//   const formatCurrency = (amount) => {
//     const num = Number(amount);
//     return `Rs.${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
//   };
//
//   const getStatusBadge = (isActive, qty) => {
//     if (!isActive) {
//       return <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-200 text-gray-700">Inactive</span>;
//     }
//     if (qty === 0) {
//       return <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-700">Out of Stock</span>;
//     }
//     if (qty < 10) {
//       return <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">Low Stock</span>;
//     }
//     return <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700">Available</span>;
//   };
//
//   const handleStartShift = () => {
//     navigate('/dashboard');
//     ToastService.info('Please start a shift first to view stocks', 'info', 3000);
//   };
//
//   return (
//     <div
//       ref={containerRef}
//       className="min-h-screen bg-gray-50 overflow-y-auto"
//       onTouchStart={handleTouchStart}
//       onTouchMove={handleTouchMove}
//       onTouchEnd={handleTouchEnd}
//     >
//       <Sidebar isOpen={showSidebar} onClose={() => setShowSidebar(false)} />
//
//       {showSidebar && (
//         <div
//           className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
//           onClick={() => setShowSidebar(false)}
//         />
//       )}
//
//       {/* Pull to Refresh Indicator */}
//       {pullDistance > 0 && (
//         <div
//           className="fixed top-0 left-0 right-0 flex items-center justify-center transition-all duration-200 z-50"
//           style={{
//             transform: `translateY(${pullDistance}px)`,
//             opacity: pullDistance / 100
//           }}
//         >
//           <div className={`bg-white rounded-full p-2 shadow-lg ${refreshing ? 'animate-spin' : ''}`}>
//             <svg
//               className="w-5 h-5 text-blue-600"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={2}
//                 d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
//               />
//             </svg>
//           </div>
//         </div>
//       )}
//
//       {/* Header */}
//       <header className="sticky top-0 z-30 bg-gradient-to-r from-[#0613cc] to-[#0613cc] shadow-lg">
//         <div className="px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between h-16">
//             <div className="flex items-center gap-3 sm:gap-4">
//               <button
//                 className="p-2 -ml-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors lg:hidden"
//                 onClick={() => setShowSidebar(true)}
//               >
//                 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//                 </svg>
//               </button>
//               <h1 className="text-lg sm:text-xl font-semibold text-white">Stock Management</h1>
//             </div>
//
//             {inventoryInfo && (
//               <span className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium bg-white/20 text-white">
//                 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
//                 </svg>
//                 {inventoryInfo.name}
//               </span>
//             )}
//           </div>
//         </div>
//       </header>
//
//       {/* Main Content */}
//       <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-7xl mx-auto">
//         {!shiftActive ? (
//           <div className="rounded-2xl shadow-lg p-8 sm:p-12 text-center bg-white">
//             <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center">
//               <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//             <h3 className="text-2xl font-bold text-gray-900 mb-3">Shift Not Started</h3>
//             <p className="text-gray-600 mb-6 max-w-md mx-auto">
//               You need to start a shift first to view stock information.
//             </p>
//             <button
//               className="px-6 py-3 rounded-lg font-semibold text-white transition-all transform hover:scale-105 active:scale-95 shadow-lg"
//               style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
//               onClick={handleStartShift}
//             >
//               <span className="flex items-center gap-2">
//                 <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                 </svg>
//                 Go to Dashboard to Start Shift
//               </span>
//             </button>
//           </div>
//         ) : (
//           <>
//             {/* Search and Controls */}
//             <div className="mb-6">
//               <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
//                 <div className="relative flex-1 max-w-md">
//                   <input
//                     type="text"
//                     placeholder="Search products..."
//                     value={searchInput}
//                     onChange={handleSearch}
//                     disabled={loading}
//                     className="w-full pl-10 pr-4 py-2.5 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                   />
//                   <svg
//                     className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                   </svg>
//                 </div>
//
//                 <div className="flex items-center gap-3">
//                   <button
//                     onClick={handleRefresh}
//                     disabled={loading}
//                     className="px-4 py-2.5 rounded-lg bg-white border-2 border-gray-200 text-gray-700 font-medium hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed transition-all"
//                   >
//                     <svg
//                       className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`}
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
//                     </svg>
//                   </button>
//                 </div>
//               </div>
//
//               {/* Mobile Inventory Badge */}
//               {inventoryInfo && (
//                 <div className="sm:hidden mt-3 flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-50 border border-blue-200">
//                   <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
//                   </svg>
//                   <span className="text-sm font-medium text-blue-900">{inventoryInfo.name}</span>
//                 </div>
//               )}
//             </div>
//
//             {/* Stock Cards */}
//             {loading ? (
//               <div className="flex flex-col items-center justify-center py-20">
//                 <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
//                 <p className="text-gray-600">Loading stock data...</p>
//               </div>
//             ) : stockData.length > 0 ? (
//               <>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
//                   {stockData.map((item) => (
//                     <div
//                       key={item.id}
//                       className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow overflow-hidden border border-gray-100"
//                     >
//                       {/* Card Header */}
//                       <div className="bg-gradient-to-r from-[#0613cc] to-[#0613cc] px-4 py-3 flex items-center justify-between">
//                         <span className="text-xs font-medium text-white/80">ID: {item.id}</span>
//                         {getStatusBadge(item.isActive, item.qty)}
//                       </div>
//
//                       {/* Card Body */}
//                       <div className="p-4 space-y-4">
//                         {/* SKU and Product Name */}
//                         <div>
//                           <div className="flex items-center gap-2 mb-2">
//                             <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
//                             </svg>
//                             <span className="text-xs text-gray-500 font-medium">SKU</span>
//                           </div>
//                           <p className="text-sm font-semibold text-gray-900">{item.product?.sku || 'N/A'}</p>
//                         </div>
//
//                         <div>
//                           <div className="flex items-center gap-2 mb-2">
//                             <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
//                             </svg>
//                             <span className="text-xs text-gray-500 font-medium">Product Name</span>
//                           </div>
//                           <p className="text-sm font-semibold text-gray-900">{item.product?.name || 'N/A'}</p>
//                         </div>
//
//                         {/* Category and Quantity */}
//                         <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-100">
//                           <div>
//                             <div className="flex items-center gap-2 mb-2">
//                               <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
//                               </svg>
//                               <span className="text-xs text-gray-500 font-medium">Category</span>
//                             </div>
//                             <p className="text-sm font-semibold text-gray-900">
//                               {item.product?.category?.name || 'Uncategorized'}
//                             </p>
//                           </div>
//
//                           <div>
//                             <div className="flex items-center gap-2 mb-2">
//                               <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
//                               </svg>
//                               <span className="text-xs text-gray-500 font-medium">Quantity</span>
//                             </div>
//                             <p className={`text-lg font-bold ${item.qty < 10 ? 'text-red-600' : 'text-gray-900'}`}>
//                               {item.qty}
//                               {item.qty < 10 && item.qty > 0 && (
//                                 <svg className="inline w-4 h-4 ml-1 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
//                                   <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
//                                 </svg>
//                               )}
//                             </p>
//                           </div>
//                         </div>
//
//                         {/* Price */}
//                         <div className="pt-3 border-t border-gray-100">
//                           <div className="flex items-center gap-2 mb-2">
//                             <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                             </svg>
//                             <span className="text-xs text-gray-500 font-medium">Unit Price</span>
//                           </div>
//                           <p className="text-lg font-bold text-green-600">
//                             {formatCurrency(item.pricePerUnit)}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//
//                 {/* Pagination */}
//                 {pagination.totalPages > 1 && (
//                   <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 bg-white rounded-xl shadow-md p-4">
//                     <button
//                       onClick={() => handlePageChange(pagination.currentPage - 1)}
//                       disabled={pagination.currentPage === 1 || loading}
//                       className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#0613cc] to-[#0613cc] text-white font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
//                     >
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                       </svg>
//                       Previous
//                     </button>
//
//                     <div className="text-center">
//                       <p className="text-sm font-semibold text-gray-900">
//                         Page {pagination.currentPage} of {pagination.totalPages}
//                       </p>
//                       {pagination.total > 0 && (
//                         <p className="text-xs text-gray-500 mt-1">
//                           {pagination.total} total items
//                         </p>
//                       )}
//                     </div>
//
//                     <button
//                       onClick={() => handlePageChange(pagination.currentPage + 1)}
//                       disabled={pagination.currentPage === pagination.totalPages || loading}
//                       className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#0613cc] to-[#0613cc] text-white font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
//                     >
//                       Next
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                       </svg>
//                     </button>
//                   </div>
//                 )}
//               </>
//             ) : (
//               <div className="rounded-2xl shadow-lg p-12 text-center bg-white">
//                 <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
//                   {searchTerm ? (
//                     <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//                     </svg>
//                   ) : (
//                     <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
//                     </svg>
//                   )}
//                 </div>
//                 <h3 className="text-xl font-bold text-gray-900 mb-2">
//                   {searchTerm ? 'No products found' : 'No stock available'}
//                 </h3>
//                 <p className="text-gray-600">
//                   {searchTerm
//                     ? `No products matching "${searchTerm}"`
//                     : 'No stock available in this inventory'}
//                 </p>
//               </div>
//             )}
//           </>
//         )}
//       </main>
//     </div>
//   );
// };
//
// export default Stocks;

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/authService';
import stockService from '../../services/stockService';
import ToastService from '../../services/toastService';
import Sidebar from '../Sidebar/Sidebar';

const Stocks = () => {
    const navigate = useNavigate();
    const [showSidebar, setShowSidebar] = useState(false);
    const [stockData, setStockData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        total: 0,
        limit: 10
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [inventoryInfo, setInventoryInfo] = useState(null);
    const [shiftActive, setShiftActive] = useState(false);

    const searchTimeoutRef = useRef(null);

    useEffect(() => {
        // Check authentication
        if (!authService.isAuthenticated()) {
            ToastService.error('Session expired. Please login again.');
            navigate('/login');
            return;
        }

        // Check if shift is active and get inventoryId
        checkShiftStatus();
    }, [navigate]);

    useEffect(() => {
        if (shiftActive && inventoryInfo?.id) {
            fetchStockData();
        }
    }, [shiftActive, inventoryInfo?.id, pagination.currentPage, searchTerm]);

    // Debounced search
    useEffect(() => {
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        searchTimeoutRef.current = setTimeout(() => {
            setSearchTerm(searchInput);
            setPagination(prev => ({ ...prev, currentPage: 1 }));
        }, 500);

        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, [searchInput]);

    const checkShiftStatus = () => {
        // Get shift data from localStorage
        const shiftDataStr = localStorage.getItem('current_shift');

        if (shiftDataStr) {
            const shiftData = JSON.parse(shiftDataStr);

            if (shiftData.isActive && shiftData.inventoryId) {
                setShiftActive(true);
                setInventoryInfo({
                    id: shiftData.inventoryId,
                    name: shiftData.inventoryName || 'Current Inventory'
                });

                // Also try to get inventory name from other localStorage items if available
                const inventoryName = localStorage.getItem('currentInventoryName');
                if (inventoryName) {
                    setInventoryInfo(prev => ({ ...prev, name: inventoryName }));
                }
            } else {
                setShiftActive(false);
                setInventoryInfo(null);
            }
        } else {
            setShiftActive(false);
            setInventoryInfo(null);
        }

        setLoading(false);
    };

    const fetchStockData = async () => {
        try {
            setLoading(true);

            const response = await stockService.getStockByInventory(
                inventoryInfo.id,
                pagination.currentPage,
                pagination.limit,
                searchTerm
            );

            if (response.success) {
                setStockData(response.data);
                setPagination({
                    ...pagination,
                    totalPages: response.pagination.totalPages,
                    total: response.pagination.total
                });
            } else {
                setStockData([]);
                setPagination({
                    ...pagination,
                    totalPages: 0,
                    total: 0
                });
            }
        } catch (error) {
            console.error('Error fetching stock data:', error);
            setStockData([]);
            setPagination({
                ...pagination,
                totalPages: 0,
                total: 0
            });

            if (error.message.includes('401') || error.message.includes('Unauthorized')) {
                ToastService.error('Session expired. Please login again.');
                navigate('/login');
            } else if (!error.message.includes('404')) {
                ToastService.error('Failed to load stock data. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e) => {
        setSearchInput(e.target.value);
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pagination.totalPages) {
            setPagination(prev => ({ ...prev, currentPage: page }));

            // Scroll to top on page change
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const formatCurrency = (amount) => {
        const num = Number(amount);
        return `Rs.${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
    };

    const getStatusBadge = (isActive, qty) => {
        if (!isActive) {
            return <span className="px-2 py-1 rounded-full text-xs font-medium bg-gray-200 text-gray-700">Inactive</span>;
        }
        if (qty === 0) {
            return <span className="px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-700">Out of Stock</span>;
        }
        if (qty < 10) {
            return <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">Low Stock</span>;
        }
        return <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-black-700">Available</span>;
    };

    const handleStartShift = () => {
        navigate('/dashboard');
        ToastService.info('Please start a shift first to view stocks', 'info', 3000);
    };

    return (
        <div
            className="min-h-screen bg-gray-50 overflow-y-auto"
        >
            <Sidebar isOpen={showSidebar} onClose={() => setShowSidebar(false)} />

            {showSidebar && (
                <div
                    className="fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity"
                    onClick={() => setShowSidebar(false)}
                />
            )}

            {/* Header */}
            <header className="sticky top-0 z-30 bg-gradient-to-r from-[#0613cc] to-[#0613cc] shadow-lg">
                <div className="px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <div className="flex items-center gap-3 sm:gap-4">
                            <button
                                className="p-2 -ml-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors lg:hidden"
                                onClick={() => setShowSidebar(true)}
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            </button>
                            <h1 className="text-lg sm:text-xl font-semibold text-white">Stock Management</h1>
                        </div>

                        {inventoryInfo && (
                            <span className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium bg-white/20 text-white">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
                </svg>
                                {inventoryInfo.name}
              </span>
                        )}
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-7xl mx-auto">
                {!shiftActive ? (
                    <div className="rounded-2xl shadow-lg p-8 sm:p-12 text-center bg-white">
                        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center">
                            <svg className="w-10 h-10 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-900 mb-3">Shift Not Started</h3>
                        <p className="text-gray-600 mb-6 max-w-md mx-auto">
                            You need to start a shift first to view stock information.
                        </p>
                        <button
                            className="px-6 py-3 rounded-lg font-semibold text-white transition-all transform hover:scale-105 active:scale-95 shadow-lg"
                            style={{ background: 'linear-gradient(135deg, #0613cc, #0613cc)' }}
                            onClick={handleStartShift}
                        >
              <span className="flex items-center gap-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Go to Dashboard to Start Shift
              </span>
                        </button>
                    </div>
                ) : (
                    <>
                        {/* Search and Controls */}
                        <div className="mb-6">
                            <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
                                <div className="relative flex-1 max-w-md">
                                    <input
                                        type="text"
                                        placeholder="Search products..."
                                        value={searchInput}
                                        onChange={handleSearch}
                                        disabled={loading}
                                        className="w-full pl-10 pr-4 py-2.5 rounded-lg border-2 border-gray-200 bg-white text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed transition-all"
                                    />
                                    <svg
                                        className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                    </svg>
                                </div>

                                <div className="flex items-center gap-3">
                                    <button
                                        onClick={fetchStockData}
                                        disabled={loading}
                                        className="px-4 py-2.5 rounded-lg bg-white border-2 border-gray-200 text-gray-700 font-medium hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed transition-all"
                                    >
                                        <svg
                                            className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`}
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                            {/* Mobile Inventory Badge */}
                            {inventoryInfo && (
                                <div className="sm:hidden mt-3 flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-50 border border-blue-200">
                                    <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
                                    </svg>
                                    <span className="text-sm font-medium text-blue-900">{inventoryInfo.name}</span>
                                </div>
                            )}
                        </div>

                        {/* Stock Cards */}
                        {loading ? (
                            <div className="flex flex-col items-center justify-center py-20">
                                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
                                <p className="text-gray-600">Loading stock data...</p>
                            </div>
                        ) : stockData.length > 0 ? (
                            <>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                                    {stockData.map((item) => (
                                        <div
                                            key={item.id}
                                            className="bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow overflow-hidden border border-gray-100"
                                        >
                                            {/* Card Header */}
                                            <div className="bg-gradient-to-r from-[#0613cc] to-[#0613cc] px-4 py-3 flex items-center justify-between">
                                                <span className="text-xs font-medium text-white/80">ID: {item.id}</span>
                                                {getStatusBadge(item.isActive, item.qty)}
                                            </div>

                                            {/* Card Body */}
                                            <div className="p-4 space-y-4">
                                                {/* SKU and Product Name */}
                                                <div>
                                                    <div className="flex items-center gap-2 mb-2">
                                                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                                                        </svg>
                                                        <span className="text-xs text-gray-500 font-medium">SKU</span>
                                                    </div>
                                                    <p className="text-sm font-semibold text-gray-900">{item.product?.sku || 'N/A'}</p>
                                                </div>

                                                <div>
                                                    <div className="flex items-center gap-2 mb-2">
                                                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                                        </svg>
                                                        <span className="text-xs text-gray-500 font-medium">Product Name</span>
                                                    </div>
                                                    <p className="text-sm font-semibold text-gray-900">{item.product?.name || 'N/A'}</p>
                                                </div>

                                                {/* Category and Quantity */}
                                                <div className="grid grid-cols-2 gap-4 pt-3 border-t border-gray-100">
                                                    <div>
                                                        <div className="flex items-center gap-2 mb-2">
                                                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                                            </svg>
                                                            <span className="text-xs text-gray-500 font-medium">Category</span>
                                                        </div>
                                                        <p className="text-sm font-semibold text-gray-900">
                                                            {item.product?.category?.name || 'Uncategorized'}
                                                        </p>
                                                    </div>

                                                    <div>
                                                        <div className="flex items-center gap-2 mb-2">
                                                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                                            </svg>
                                                            <span className="text-xs text-gray-500 font-medium">Quantity</span>
                                                        </div>
                                                        <p className={`text-lg font-bold ${item.qty < 10 ? 'text-red-600' : 'text-gray-900'}`}>
                                                            {item.qty}
                                                            {item.qty < 10 && item.qty > 0 && (
                                                                <svg className="inline w-4 h-4 ml-1 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                                                                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                                </svg>
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* Price */}
                                                <div className="pt-3 border-t border-gray-100">
                                                    <div className="flex items-center gap-2 mb-2">
                                                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                        </svg>
                                                        <span className="text-xs text-gray-500 font-medium">Unit Price</span>
                                                    </div>
                                                    <p className="text-lg font-bold text-green-600">
                                                        {formatCurrency(item.pricePerUnit)}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Pagination */}
                                {pagination.totalPages > 1 && (
                                    <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 bg-white rounded-xl shadow-md p-4">
                                        <button
                                            onClick={() => handlePageChange(pagination.currentPage - 1)}
                                            disabled={pagination.currentPage === 1 || loading}
                                            className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#0613cc] to-[#0613cc] text-white font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
                                        >
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                            </svg>
                                            Previous
                                        </button>

                                        <div className="text-center">
                                            <p className="text-sm font-semibold text-gray-900">
                                                Page {pagination.currentPage} of {pagination.totalPages}
                                            </p>
                                            {pagination.total > 0 && (
                                                <p className="text-xs text-gray-500 mt-1">
                                                    {pagination.total} total items
                                                </p>
                                            )}
                                        </div>

                                        <button
                                            onClick={() => handlePageChange(pagination.currentPage + 1)}
                                            disabled={pagination.currentPage === pagination.totalPages || loading}
                                            className="w-full sm:w-auto px-4 py-2.5 rounded-lg bg-gradient-to-r from-[#0613cc] to-[#0613cc] text-white font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
                                        >
                                            Next
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </button>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="rounded-2xl shadow-lg p-12 text-center bg-white">
                                <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
                                    {searchTerm ? (
                                        <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                        </svg>
                                    ) : (
                                        <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                        </svg>
                                    )}
                                </div>
                                <h3 className="text-xl font-bold text-gray-900 mb-2">
                                    {searchTerm ? 'No products found' : 'No stock available'}
                                </h3>
                                <p className="text-gray-600">
                                    {searchTerm
                                        ? `No products matching "${searchTerm}"`
                                        : 'No stock available in this inventory'}
                                </p>
                            </div>
                        )}
                    </>
                )}
            </main>
        </div>
    );
};

export default Stocks;